import { Button } from "@/styles/ui/button";
import { Loader2 } from "lucide-react";
import { withDevModeComponent } from "@/components/hoc/with-dev-mode-component";

interface FuzzButtonProps {
  onFuzz?: () => void;
  isFuzzing?: boolean;
  disabled?: boolean;
}

const FuzzButton = ({
  onFuzz,
  isFuzzing = false,
  disabled = false,
}: FuzzButtonProps) => {
  return (
    <Button
      onClick={onFuzz}
      disabled={disabled || isFuzzing}
      size="lg"
      variant="outline"
      className="px-8 h-12 text-base"
    >
      {isFuzzing ? (
        <>
          <Loader2 className="w-5 h-5 animate-spin mr-2" />
          Fuzzing 중...
        </>
      ) : (
        "Fuzz"
      )}
    </Button>
  );
};

export const FuzzButtonDevMode = withDevModeComponent(FuzzButton);
